export default "__VITE_ASSET__D0AnNPix__"